import { TextArea, TextInput, WithErrorForm } from "components/common";
import { Modal, ModalProps } from "components/common/Modal";
import { Button } from "components/parts/Button/Button";
import { Typography } from "components/parts/Typography/Typography";
import {
  StyledButtonArea,
  StyledForm,
  StyledFormRow,
  StyledMediaContainer,
  StyledModalContent,
  StyledModalFooter,
  StyledModalHeader,
  StyledTitle,
} from "pages/FileManagement/FileManageModal/styled";
import { DisplayFileResource } from "pages/FileManagement/hook";
import React from "react";
import { FileResource, ResourceType } from "types/graphqlapi";
import { FormikProps } from "formik";
import { FileResourceFormValueType } from "pages/FileManagement";
import { ImagePresenter } from "components/common/ImagePresenter";
import { VideoPresenter } from "components/common/VideoPresenter";

type FileManageModalProps = {
  selectedFile?: DisplayFileResource;
  fileFormik: FormikProps<FileResourceFormValueType>;
  onDeleteButtonHandler: (interviewResouce: FileResource) => Promise<void>;
} & ModalProps;

export const FileManageModal: React.FC<FileManageModalProps> = ({
  selectedFile,
  fileFormik,
  onDeleteButtonHandler,
  closeHandler,
}) => {
  const isEditFile = !!selectedFile?.id;

  const src = isEditFile
    ? selectedFile.src
    : fileFormik.values.file && URL.createObjectURL(fileFormik.values.file);

  const isVideo = isEditFile
    ? selectedFile.type === ResourceType.VIDEO
    : fileFormik.values.file?.type.includes("video");

  return (
    <Modal closeHandler={closeHandler}>
      <StyledForm onSubmit={fileFormik.handleSubmit}>
        <StyledModalHeader>
          {isEditFile ? (
            <StyledTitle text="ファイル編集" size="large" />
          ) : (
            <StyledTitle text="ファイルの詳細" size="large" />
          )}
        </StyledModalHeader>
        <StyledModalContent>
          <StyledFormRow>
            <StyledMediaContainer>
              {isVideo ? (
                <VideoPresenter src={src} controls maxHeight={"20rem"} />
              ) : (
                <ImagePresenter
                  src={src}
                  onClick={() => window.open(src)}
                  maxHeight={"20rem"}
                  pointer
                />
              )}
            </StyledMediaContainer>
          </StyledFormRow>
          <StyledFormRow>
            <Typography text="タイトル" required />
            <WithErrorForm
              touched={fileFormik.touched.title}
              errorMessage={fileFormik.errors.title}
            >
              <TextInput
                autoFocus
                {...fileFormik.getFieldProps("title")}
                width="20rem"
                maxlength="30"
              />
            </WithErrorForm>
          </StyledFormRow>
          <StyledFormRow>
            <Typography text="説明文" />
            <WithErrorForm
              touched={fileFormik.touched.description}
              errorMessage={fileFormik.errors.description}
            >
              <TextArea
                {...fileFormik.getFieldProps("description")}
                width="20rem"
                maxlength="150"
              />
            </WithErrorForm>
          </StyledFormRow>
        </StyledModalContent>
        <StyledModalFooter>
          <StyledButtonArea>
            {isEditFile && (
              <Button
                onClick={() => {
                  onDeleteButtonHandler(selectedFile);
                }}
                variant="secondary"
                text="削除"
                type="button"
              />
            )}
            <Button text={isEditFile ? "更新" : "保存"} type="submit" />
          </StyledButtonArea>
        </StyledModalFooter>
      </StyledForm>
    </Modal>
  );
};
